import { PipeTransform, Pipe } from '@angular/core';
import { TableRowItem } from '../table.interface';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Subject, Observable, of, concat } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';

@Pipe({
  name: 'searchColumn',
  pure: false

})

export class SearchColumnPipe implements PipeTransform {
  transform(rows: any, filter: any): TableRowItem {
    let filteredRows = rows;
    if (!Array.isArray(rows)) {
      return rows;
    }
    if (filter && Array.isArray(rows)) {
      for (let i = 0; i < Object.keys(filter).length; i++) {
        const queryValue = filter[Object.keys(filter)[i]];
        if (queryValue) {
          filteredRows = rows.filter(row => row.cells[i].title.toString().includes(queryValue));
          rows = filteredRows;
        }
      }
      return filteredRows;
    }
  }
}

@Pipe({
  name: 'basicSearch',
  pure: false

})

export class BasicSearchPipe implements PipeTransform {
  transform(rows: any, filter: any): any {
    // TODO: update filtering to filter combination of inputs
    //     const filteredRows = [];
    //     if (!filter) {
    //       return rows;
    //     }
    //     if (!Array.isArray(rows)) {
    //       return rows;
    //     }
    //     if (filter && Array.isArray(rows)) {
    //       console.log(filter);
    //       rows.forEach(row => {
    //         for (let i = 0; i < row.cells.length; i++) {
    //           const cell = row.cells[i];
    //           if (cell.title.toString().includes(filter)) {
    //             filteredRows.push(row);
    //             break;
    //           }
    //         }
    //       });
    //       return filteredRows;
    //     }
    return rows;
  }
}

@Pipe({
  name: 'filterByDate',
  pure: false

})
// TODO: convert date picker to basicFilter pipe

export class FilterByDatePipe implements PipeTransform {
  transform(rows: any, filter: any = null): any {
    const filteredRows = [];
    if (!filter) {
      return rows;
    }
    if (!filter.startDate || !filter.endDate) {
      return rows;
    }
    if (!Array.isArray(rows)) {
      return rows;
    }
    if (filter.startDate && filter.endDate && Array.isArray(rows)) {
      rows.forEach(row => {
        for (let i = 0; i < row.cells.length; i++) {
          const cell = row.cells[i];
          if (cell.type === 'date') {
            if (cell.title >= filter.startDate && cell.title <= filter.endDate) {
              filteredRows.push(row);
            }
          }
        }
      });
      return filteredRows;
    }
  }
}

@Pipe({
  name: 'serverSearch',
  pure: false

})

export class ServerSearchPipe implements PipeTransform {
  transform(url: string, searchQuery) {
    // let row = [];
    if (url && searchQuery) {
      // searchQuery.pipe(
      //   debounceTime(200);
      //   startWith()
      // )
    }
  }

  query(http: HttpClient, baseUrl: string, searchOption?: string | object): Observable<any> {
    let params = new HttpParams();
    let url = baseUrl;
    if (typeof searchOption === 'string') {
      // we were given a page URL, use it
      url = searchOption;
    } else if (typeof searchOption === 'object') {
      // we were given filtering criteria, build the query string
      Object.keys(searchOption)
        .sort()
        .forEach(key => {
          const value = searchOption[key];
          if (value !== null) {
            params = params.set(key, value.toString());
          }
        });
    }
    return http.get(url, {
      params
    });
  }
}